import { Components, Theme } from "@mui/material";

export const MuiTooltip: Components<Theme>["MuiTooltip"] = {
  defaultProps: {
    arrow: true,
  },
  styleOverrides: {
    tooltip: ({ theme }) => ({
      backgroundColor: theme.palette.text.primary,
      padding: theme.spacing(1),
      fontSize: theme.typography.body2.fontSize,
    }),
    arrow: ({ theme }) => ({
      color: theme.palette.text.primary,
    }),
  },
};
